import { CheckHistoryTypes } from './check-history-types';

/**
 * History entry types that get the row "View" hover action (same targets as the former inline
 * background-checks link). Keep in sync anywhere HistoryRow receives onView.
 */
export const VIEW_LINK_TYPES = new Set([
  CheckHistoryTypes.NewCheck,
  CheckHistoryTypes.BackgroundCheckProcessing,
  CheckHistoryTypes.BackgroundCheckCompleted,
  CheckHistoryTypes.BackgroundCheckUpdated,
  CheckHistoryTypes.SubCheckCompleted,
]);

/**
 * Whether `type` belongs to `set`. `check_history.type` may arrive as a string from JSON while
 * CheckHistoryTypes values are numbers; `Set.has` uses strict equality.
 */
export function historyTypeInSet(set, type) {
  if (type === null || type === undefined) return false;
  if (set.has(type)) return true;
  const n = Number(type);
  return Number.isFinite(n) && set.has(n);
}
